import {Text} from '../atoms/Text/Text';
import {MobileLayoutRegisterHeaderProps} from './MobileLayoutRegisterHeaderProps.interface';

export function MobileLayoutRegisterHeader({
  headerTitle,
}: MobileLayoutRegisterHeaderProps) {
  return (
    <div className="flex h-mobile_header_height_px w-full items-center bg-theme-bg-base-alt pl-15pxr">
      <Text className="font-medium2-bold text-theme-solid-100">
        {headerTitle}
      </Text>
    </div>
  );
}
